import React, { useEffect, useState } from 'react';

// Wrapper that dynamically imports `react-hls-player` on the client only.
// This prevents the server-side build (CommonJS) from trying to parse an
// ESM-distributed package which causes "Cannot use import statement outside a module".
const ReactHlsPlayerWrapper = (props) => {
  const [Player, setPlayer] = useState(null);

  useEffect(() => {
    let mounted = true;
    // Dynamically import the real player only in the browser
    import('react-hls-player')
      .then((mod) => {
        if (!mounted) return;
        // Support both default export and named export
        const P = mod && (mod.default || mod);
        setPlayer(() => P);
      })
      .catch((err) => {
        // Fail silently on import errors — we prefer graceful degradation
        // and do not want server-side builds to crash.
        // You can add logging here if you want to capture client errors.
        console.warn('react-hls-player dynamic import failed', err);
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (!Player) return null;

  return <Player {...props} />;
};

export default ReactHlsPlayerWrapper;
